import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  footerSmallLeft: {
    id: 'Footer small left text',
    defaultMessage: '© Università di Macerata. All right reserved.',
  },
});
const FooterSmallLeft = () => {
  const intl = useIntl();

  return (
    <div className="footer-small-left">
      {intl.formatMessage(messages.footerSmallLeft)}
    </div>
  );
};

export default FooterSmallLeft;
